export default __webpack_public_path__ + "static/media/play-button-blue.173e21b0.svg";